export default {"src":"/_next/static/media/automate.72811f47.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};